module.exports = __webpack_public_path__ + "img/1620026305.006320fa.jpg";